export const toBase64 = attach =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(attach)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
    })